<div class="container">
  <form [formGroup]="addSignatureForm" (ngSubmit)="fetchPatchCurrentUserSignature()">
    <mat-toolbar>      
      <span>Firma Electr&oacute;nica</span>
      <span class="sgd-spacer"></span>
      @if (addSignatureForm.controls.signatureStatus.value=="REGISTRADA") {
          <button type="button" [disabled]="fetchingUpdateSignature" mat-flat-button (click)="onQuitarFirma()">
            <div class="btn-login-content">
              @if (fetchingUpdateSignature) {
              <mat-spinner diameter="20" color="warn"></mat-spinner>
              }@else{
              Quitar firma
              }
            </div>
          </button>
          &nbsp;
        }
      &nbsp;

      <button type="submit" [disabled]="!addSignatureForm.valid || fetchingUpdateSignature" mat-flat-button>
        <div class="btn-login-content">
          @if (fetchingUpdateSignature) {
          <mat-spinner diameter="20" color="warn"></mat-spinner>
          }@else{
          Guardar
          }
        </div>
      </button>
    </mat-toolbar>
    <br>
    <div class="row">
      <div class="col-12 col-md-6">
        <file-upload formControlName="signature" class="full-width" [fileslimit]="1" accept=".p12" class="file-upload"
          simple>
          <ng-template #placeholder>
            @if (addSignatureForm.controls.signature.value?.at(0)) {
            {{addSignatureForm.controls.signature.value?.at(0)?.name}}
            }@else {
            Eligir archivo*
            }
          </ng-template>
          <ng-template #button>
            <div class="file-button">
              <mat-icon>
                attach_file
              </mat-icon>
              <span>Subir</span>
            </div>
          </ng-template>
        </file-upload>
        @if (addSignatureForm.controls.signature.hasError('filesLimit')) {
        <mat-error class="files-container-label">{{ filesLimitMessageError }}</mat-error>
        }
        @if (addSignatureForm.controls.signature.hasError('sizeLimit')) {
        <mat-error class="files-container-label">M&aacute;ximo 40 MB</mat-error>
        }@else{
        <mat-label class="files-container-label">{{updateKBsUsedDisplay()}}</mat-label>
        }
      </div>
      <div class="col-12 col-md-6">
        <mat-form-field class="full-width">
          <mat-label>Constrase&ntilde;a firma (Opcional)</mat-label>
          <input matInput formControlName="desc" type="password" />
          <mat-icon matPrefix matTooltip="Permite verificar si la firma es v&aacute;lida, y obtener la fecha de caducidad">help</mat-icon>
        </mat-form-field>
      </div>
      <div class="col-12">
        <mat-form-field class="full-width">
          <mat-label>Estado</mat-label>
          <input matInput formControlName="signatureStatus" type="text" readonly />
        </mat-form-field>
      </div>
    </div>
  </form>
  <br>
  <div class="row">
    <div class="col-12">
      <mat-card appearance="outlined" class="full-width">
        <mat-card-header>
          <mat-card-title><mat-icon color="accent">warning</mat-icon>&nbsp;Importante:</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <ul>
            <li>
              La firma electr&oacute;nica es regulada por la <a href="https://www.firmadigital.gob.ec/normativa/"
                target="_blank">Ley de Comercio Electr&oacute;nico.</a>
            </li>
            <li>
              La firma electr&oacute;nica es soportada en archivo con extensi&oacute;n P12.
            </li>
            <li>
              No se almacenan claves de la firma electr&oacute;nica por seguridad. Sea responsable con su firma
              electr&oacute;nica.
            </li>
            <li>
              No comparta con nadie la clave de su firma electr&oacute;nica y dele siempre un buen uso.
            </li>
          </ul>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
